const locale = {
  message_success: 'Successful',
  message_info: 'Info',
  message_warning: 'Warning',
  message_error: 'Error'
};
export default locale;